import { CustomAction } from '..';
import { Product_Sel_Obj } from './product.reducers';
import { Variant_Obj } from './product_list.reducers';

export interface Signup_Details_Obj {
    email: string;
    product: Product_Sel_Obj | null;
    variant?: Variant_Obj | null;
    device_additional?: boolean;
    device_add_quantity?: number;
    country?: string;
    city?: string;
    street_name?: string;
    address_other?: string;
    business_name?: string;
    country_code?: string;
    mobile_number?: string;
    mobile_valid?: boolean;
}

export const signup_default_value: Signup_Details_Obj = {
    email: '',
    product: null,
    variant: null,
    device_additional: false,
    device_add_quantity: 0,
    country: '',
    city: '',
    street_name: '',
    address_other: '',
    business_name: '',
    country_code: '',
    mobile_number: '',
    mobile_valid: false
}

export interface Signup_Details_Actions {
    undefined: Function;
    SIGNUP_DETAILS_UPDATE: Function;
}

export const actions: Signup_Details_Actions = {
    'undefined': (state = null, payload: any) => state,
    SIGNUP_DETAILS_UPDATE: (state: Signup_Details_Obj, payload: Signup_Details_Obj) => {
        if (state == null) return {...payload};
        if (payload == null) return {...state};
        else {
            return {
                ...state,
                ...payload
            }
        } 
    }
};

export function signupDetailsReducer (state: Signup_Details_Obj, action: CustomAction): Signup_Details_Obj {
    if (['SIGNUP_DETAILS_UPDATE'].includes(action.type) && Object.keys(actions).includes(action.type)) return actions[action.type](state, action.payload);

    return state != undefined ? state : signup_default_value;
}


// WEBPACK FOOTER //
// ./src/store/reducers/signup_details.reducers.ts